__webpack_require__.p = "/scancam-edge/";